import { apiClient } from '@/services/API';

export const BASE_URL = '/api/users';

export const getFullUser = () => apiClient.get(`${BASE_URL}/current`);
